import { createContext, useContext, useState } from "react";
import {
  useKeyboardShortcuts,
  createSearchShortcuts,
} from "@/hooks/use-keyboard-shortcuts";
import { SearchPalette } from "./nav/search-palette";

interface GlobalKeyboardShortcutsContextType {
  openSearch: () => void;
  isSearchOpen: boolean;
}

const GlobalKeyboardShortcutsContext =
  createContext<GlobalKeyboardShortcutsContextType | null>(null);

export function useGlobalShortcuts() {
  const context = useContext(GlobalKeyboardShortcutsContext);
  if (!context) {
    throw new Error(
      "useGlobalShortcuts must be used within GlobalKeyboardShortcutsProvider",
    );
  }
  return context;
}

interface GlobalKeyboardShortcutsProviderProps {
  children: React.ReactNode;
}

export function GlobalKeyboardShortcutsProvider({
  children,
}: GlobalKeyboardShortcutsProviderProps) {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const openSearch = () => setIsSearchOpen(true);

  // Register global keyboard shortcuts
  useKeyboardShortcuts(createSearchShortcuts(openSearch));

  const value = {
    openSearch,
    isSearchOpen,
  };

  return (
    <GlobalKeyboardShortcutsContext.Provider value={value}>
      {children}
      <SearchPalette open={isSearchOpen} onOpenChange={setIsSearchOpen} />
    </GlobalKeyboardShortcutsContext.Provider>
  );
}
